import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../utils/error-handler';
import { environment } from '../../environments/environment';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Globals } from '../globals';
import { MenuItem } from 'primeng/api';
import { LabEmitterService } from '../common-services/lab-emitter.service';
import { Router } from '@angular/router';
import { AuthUtil } from '../common-services/auth-util';
import * as jwt_decode from 'jwt-decode'
import { SelectableLab } from '../masterdata/models/lab';
import { HeaderService } from './header.service.';

// Header menu to handle navigation. This is dynamic menu and it has to be handled based on lab selection
// Author: Naveen
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    buildNo: string;
    mdmServiceBuildNo: string;
    apiGatewayServiceBuildNo: string;
    apgServiceBuildNo: string;
    ngsEntryQcBuildNo: string;
    ngsRunPlanningBuildNo: string;
    animalOrderServiceBuildNo:string;
    labMeasurementServiceBuildNo:string;
    sampleReceptionServiceBuildNo:string;
    ngsLibPrepServiceBuildNo:string;
    TicketServiceBuildNo:string;

    production: boolean;
    errorHandler: ErrorHandler = new ErrorHandler;

    selectedLab: SelectableLab;
    loggedUserName: string;
    isMPC: boolean = false;
    isNGS: boolean = false;
    isAPG: boolean = false;
    otherLab: boolean = false;
    isSanger: boolean = false;
    isGenotyping: boolean = false;

    readonly COLOGNE = "COLOGNE"
    readonly AARHUS = "AARHUS"
    readonly EBERSBERG = "EBERSBERG"
    readonly MPC_EBE = "MPC_EBE"
    readonly NGS_CONSTANCE = "NGS_CONSTANCE"
    readonly APG = "APG"

    readonly BU_SANGER = "Sanger Sequencing"
    readonly BU_GENOTYPING = "Genotyping"
    readonly BU_NGS = "Next Generation Sequencing"
    readonly BU_APG = "Applied Genomics"

    readonly RUN_PLAN = "Run Planning"
    readonly RUN_SCHEDULE = "Run Scheduling"
    readonly RUN_PROCESS = "Run Processing"
    readonly ON_HOLD_PROJECT = "On hold Projects"
    readonly RUN_TRACK_LIBRARIES = "Track Libraries"
    link: MenuItem[];
    runOptions: MenuItem[];
    constructor(private _globals: Globals, private router: Router, private _headerService: HeaderService, private _labEmitterService: LabEmitterService) { }
      
    // initilizes the build info
    ngOnInit() {

        this.initializeBuildInfo();
        this.getBuildInfo();
        this.getServiceBuildInfo();

        
        this._labEmitterService.change.subscribe(lab => {
            this.selectedLab = lab;
            console.log("Seleted lab in header(e): " + this.selectedLab.label)
            this.checkSelectedLab()
        });

        this.selectedLab = JSON.parse(localStorage.getItem('lab'));
        if (this.selectedLab) {
            console.log("Seleted lab in header: " + this.selectedLab.label)
            this.checkSelectedLab()
        }

        this.production = environment.production;

        this.link = [
            {
                label: 'Change Lab', command: () => {
                    this.changeLab();
                }
            }
        ];
        this.runOptions = [
            {
                label: 'Run Planning', command: () => {
                    this.changeRunForNavigation(this.RUN_PLAN);
                }
            }, {
                label: 'Run Scheduling', command: () => {
                    this.changeRunForNavigation(this.RUN_SCHEDULE);
                },
            }, {
                label: 'Run Processing', command: () => {
                    this.changeRunForNavigation(this.RUN_PROCESS);
                }
            }, {
                label: 'On hold Projects', command: () => {
                    this.changeRunForNavigation(this.ON_HOLD_PROJECT);
                }
            }
        ];
    }
    get loginStatus() {
        return localStorage.getItem('currentUser') ? true : false;
    }

    get azureLoginStatus() {
        let authUtil = new AuthUtil()
        let accessToken = authUtil.getAccessToken()
        if(accessToken)
        {
        let access_token = jwt_decode(accessToken);
        this.loggedUserName= access_token.name;
        let uniqueId = access_token.upn ? access_token.upn : access_token.unique_name 
        let loggedUserPUID = this.getPUIDFromUPN(uniqueId);
        localStorage.setItem('PUID', loggedUserPUID);
        }
        return accessToken ? true : false
    }

    logOut() {
        localStorage.removeItem('currentUser');
    }

    azureLogOut() {
        const util = new AuthUtil()
        util.logout()

    }

    changeRunForNavigation(label: string) {
        localStorage.removeItem('run');
        let selectedLabel = label;
        switch (selectedLabel) {
            case this.RUN_PLAN: {
                this.router.navigate(['/runplan'])
                break;
            }
            case this.RUN_SCHEDULE: {
                this.router.navigate(['/'])
                break;
            }
            case this.RUN_PROCESS: {
                this.router.navigate(['/runprocess'])
                break;
            }
            case this.ON_HOLD_PROJECT: {
                this.router.navigate(['/runplan/onholdproject'])
                break;
            }
            case this.RUN_TRACK_LIBRARIES: {
                this.router.navigate(['/runplan/trackLibraies'])
                break;
            }
        }
    }

    // checks the selected lab
    checkSelectedLab() {
        switch (this.selectedLab.lab.businessArea.name) {
            case this.BU_SANGER: {
                this.isSanger = true;
                break;
            }
            case this.BU_GENOTYPING: {
                this.isGenotyping = true;
                break;
            }
            case this.BU_APG: {
                this.isAPG = true;
                break;
            }
            case this.MPC_EBE: {
                this.isMPC = true;
                break;
            }
            case this.BU_NGS: {
                this.isNGS = true;
                break;
            }

            default: {
                this.otherLab = true;
                break;
            }
        }
    }

    // chnages the lab and loads lab page
    changeLab() {

        this.isMPC = false;
        this.isNGS = false;

        this.otherLab = false;
        this.isSanger = false;
        this.isGenotyping = false;
        this.isAPG = false;
        this.isNGS = false;

        localStorage.removeItem('lab');
        this.router.navigate(['/']).then(nav => {
            console.log(nav); // true if navigation is successful
            if (nav === null) {
                console.log("Reloading...");
                window.location.reload();
            }
        }, err => {
            window.location.reload();
            console.log(err) // when there's an error
        });
    }

    // initilizes the build info
    initializeBuildInfo() {
        this.buildNo = '== DEV ==';
        this.mdmServiceBuildNo = 'n/a';
        this.apiGatewayServiceBuildNo = 'n/a';
        this.ngsEntryQcBuildNo = 'n/a';
        this.apgServiceBuildNo = 'n/a';
        this.ngsRunPlanningBuildNo= 'n/a';
        this.animalOrderServiceBuildNo= 'n/a';
        this.sampleReceptionServiceBuildNo= 'n/a';
    }

    getBuildInfo() {
        console.log("Pulling build info");
        this._headerService.getBuildInfo().subscribe(
            results => {
                console.log('BUILD: ' + results.Build.Number);
                if (results.Build.Number.length > 0) {
                    this.buildNo = results.Build.Number;
                }
            }
        );
    }

    // service call for the build info
    getServiceBuildInfo() {

        this._headerService.getServiceBuildInfo(environment.BB_MDMSERVICE_URL).subscribe(
            results => {
                console.log("MDM service: " + results.data.Build.Number);
                this.mdmServiceBuildNo = results.data.Build.Number;
            }
        );

        this._headerService.getServiceBuildInfo(environment.BB_APIGATEWAY_SERVICE_URL).subscribe(
            results => {
                console.log("APIGateway : " + results.data.Build.Number);
                this.apiGatewayServiceBuildNo = results.data.Build.Number;
            }
        );

        this._headerService.getServiceBuildInfo(environment.BB_NGS_ENTRY_QC_URL).subscribe(
            results => {
                console.log("NGS Entry QC Service: " + results.data.Build.Number);
                this.ngsEntryQcBuildNo = results.data.Build.Number;
            }
        );

        this._headerService.getServiceBuildInfo(environment.BB_APG_SAMPLE_PROCESSING_URL).subscribe(
            results => {
                console.log("APG Service: " + results.data.Build.Number);
                this.apgServiceBuildNo = results.data.Build.Number;
            }
        );

        this._headerService.getServiceBuildInfo(environment.BB_NGS_RUN_PLANNING_URL).subscribe(
            results => {
                console.log("NGS RunPlanning Service: " + results.data.Build.Number);
                this.ngsRunPlanningBuildNo = results.data.Build.Number;
            }
        );

        this._headerService.getServiceBuildInfo(environment.BB_ANIMAL_ORDER_SERVICE_URL).subscribe(
            results => {
                console.log("Animal Order Service: " + results.data.Build.Number);
                this.animalOrderServiceBuildNo = results.data.Build.Number;
            }
        );

        this._headerService.getServiceBuildInfo(environment.BB_LAB_MEASUREMENT_URL).subscribe(
            results => {
                console.log("Lab Measurement: " + results.data.Build.Number);
                this.labMeasurementServiceBuildNo = results.data.Build.Number;
            }
        );

        this._headerService.getServiceBuildInfo(environment.BB_SAMPLE_RECEPTION_SERVICE_URL).subscribe(
            results => {
                console.log("Sample Reception: " + results.data.Build.Number);
                this.sampleReceptionServiceBuildNo = results.data.Build.Number;
            }
        );

        this._headerService.getServiceBuildInfo(environment.BB_NGS_LIB_PREP_URL).subscribe(
            results => {
                console.log("LIB Prep: " + results.data.Build.Number);
                this.ngsLibPrepServiceBuildNo = results.data.Build.Number;
            }
        );

        this._headerService.getServiceBuildInfo(environment.BB_TICKET_SERVICE_URL).subscribe(
            results => {
                console.log("Ticket Service: " + results.data.Build.Number);
                this.TicketServiceBuildNo = results.data.Build.Number;
            }
        );

    }

    // binding build info
    showBuildInfo(event, overlaypanel: OverlayPanel) {
        overlaypanel.toggle(event);
    }

    getPUIDFromUPN(upn: string) {
        return upn.includes('@') ? upn.substring(0, upn.indexOf('@')) : '';
    }
}
